/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/UserOrganizations/UserOrganizations',[
    'jquery',
    'lodash',
    'global/all',
    './UserOrganizations.Selectors',
    './UserOrganizations.Helper',
    './UserOrganizations.Forms',
    './UserOrganizationsService',
    'modules/User/Users'
], function ($, _, Roc, Selectors, UserOrganizationsHelper, UserOrganizationsForms, UserOrganizationsService, Users) {
    'use strict';
    var viewModel = {};
    var maxDayOfRenew = 31;
    /* Events */

    function editBudgetEvt() {
        $(document)
            .off('click', Selectors.buttons.editBudget)
            .on('click', Selectors.buttons.editBudget, function () {
                var organizationId = $(this).data("organizationId");
                var editedOrganization = _.find(viewModel.organizations, { 'id': organizationId });

                _.extend(editedOrganization, { availableDaysOfRenew: viewModel.availableDaysOfRenew });

                Roc.UI.template('organizationBudgetForm-Tmp', editedOrganization)
                    .then(function (renderedTemplate) {
                        var budgetFormWrapper = $(Selectors.wrappers.organizationBudgetForm);
                        budgetFormWrapper.html(renderedTemplate);
                        bindFormEvents(editedOrganization);
                        var budgetRenewalDayOfMonthField = budgetFormWrapper.find(Selectors.fields.renewalDayOfMonth);
                        $(budgetRenewalDayOfMonthField).val(editedOrganization.customFields.customerBudgetRenewalDayOfMonth);
                        Roc.UI.openForm(Selectors.wrappers.organizationBudgetForm);
                    });
                $(Selectors.fields.customerBudget).focus();
            });
    }

    function updateBudgetEvt() {
        $(document)
            .off('click', Selectors.buttons.submitBudget)
            .on('click', Selectors.buttons.submitBudget, function (e) {

                var submitButton = e.currentTarget;

                if (!Roc.Validation.validateForm(UserOrganizationsForms.OrganizationBudget)) {
                    return;
                }

                Roc.Core.lockButton(submitButton);

                var budgetFormWrapper = $(Selectors.wrappers.organizationBudgetForm);

                var organizationId = budgetFormWrapper.find('.formWrapper').data('organizationId');

                var customerBudgetField = budgetFormWrapper.find(Selectors.fields.customerBudget);
                var budgetRenewalDayOfMonthField = budgetFormWrapper.find(Selectors.fields.renewalDayOfMonth);

                var customerBudget = parseFloat($(customerBudgetField).val());
                var budgetRenewalDayOfMonth = $(budgetRenewalDayOfMonthField).val();

                var requestData = {
                    'OrganizationId': organizationId,
                    'Budget': customerBudget,
                    'BudgetRenewalDayOfMonth': budgetRenewalDayOfMonth

                };

                UserOrganizationsService.updateCustomerBudget(requestData)
                    .then(function (updatedOrganization) {
                        refreshOrganization(updatedOrganization);
                        Roc.UI.closeForm(Selectors.wrappers.organizationBudgetForm);
                        Roc.UI.info('Customer budget was successfully updated.');
                    })
                    .fail(function (xhr) {
                        Roc.UI.ajaxErrorPopup(xhr);
                    })
                    .always(function () {
                        Roc.Core.releaseLockedButton(submitButton);
                    });
            });
    }

    function cancelFormEvt() {
        $(document)
            .off('click', Selectors.buttons.cancelBudget)
            .on('click',
                Selectors.buttons.cancelBudget,
                function (e) {
                    var budgetFormWrapper = $(Selectors.wrappers.organizationBudgetForm);
                    var customerBudgetField = budgetFormWrapper.find(Selectors.fields.customerBudget);
                    var budgetRenewalDayOfMonthField = budgetFormWrapper.find(Selectors.fields.renewalDayOfMonth);
                    customerBudgetField.val('');
                    budgetRenewalDayOfMonthField.val(1);
                    Roc.UI.closeForm(Selectors.wrappers.organizationBudgetForm);
                });
    }

    

    

    /* bind events */

    function bindFormEvents() {
        updateBudgetEvt();
        cancelFormEvt();
        
    }
    function bindEvents() {
        editBudgetEvt();
    };

    function refreshOrganization(updatedOrganization) {
        _.extend(_.findWhere(viewModel.organizations, { id: updatedOrganization.id }), updatedOrganization);
        loadOrganizations();
    }

    function loadOrganizations() {
        Roc.UI.template('userShipToOrganization-Tmp', viewModel)
            .then(function (renderedTemplate) {

                $(Selectors.wrappers.shipToOrganizations).html(renderedTemplate);

                bindEvents();
            });
    }
    function setAvailableRenewalDays() {
        var availableDaysOfRenew = [];
        for (var i = 0; i < maxDayOfRenew; i++) {
            availableDaysOfRenew.push(i + 1);
        }
        viewModel.availableDaysOfRenew = availableDaysOfRenew;
    }
    function init(model) {
        viewModel = model;
        setAvailableRenewalDays();
        loadOrganizations();
    };

    var UserOrganizations = {
        init: init
    };

    Roc.Logger.debug('UserOrganizations.js Loaded:', UserOrganizations);
    return UserOrganizations;
});
